import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import ParchmentBackground from "../../components/ParchmentBackground";
import { GraphPrintzView } from "../../components/mycraftz/GraphPrintzDashboard";
import { BookJourney } from "../MyJourneyPage";
import { AdminJourneyPdfButton } from "./AdminUsersPanel";
import "../../styles/MyCraftzPage.css";
import "../../styles/GraphPrintz.css";

const API = process.env.REACT_APP_BACKEND_URL;

/* Admin-only, read-only mirror of a user's GraphPrintz + My Journey. */
export default function AdminUserViewPage() {
  const { userId } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("icraftz_admin_token") || "";
    axios.get(`${API}/api/admin/users/${userId}/journey`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setData(r.data))
      .catch((e) => setError([401, 403].includes(e.response?.status) ? "Admin sign-in required — open /admin and sign in first." : "Failed to load user."));
  }, [userId]);

  if (error) return <div className="mc-page"><p className="gpd-meaning" data-testid="auv-error">{error} <Link to="/admin">Back to admin</Link></p></div>;
  if (!data) return <div className="mc-page"><p className="gpd-meaning">Opening dashboard…</p></div>;

  return (
    <div className="mc-page" data-testid="admin-user-view-page">
      <div className="adm-view-banner" data-testid="auv-banner">Viewing as admin — read-only — <strong style={{ color: "inherit" }}>{data.user.email}</strong></div>
      <ParchmentBackground />
      <div className="gpd auv-actions" style={{ paddingBottom: 0, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
        <Link to={`/admin/users/${userId}`} className="mj-link" data-testid="auv-back">← Back to user detail</Link>
        <AdminJourneyPdfButton userId={userId} token={localStorage.getItem("icraftz_admin_token") || ""} testId="auv-download-pdf" />
      </div>
      <GraphPrintzView data={data.overview} readOnly />
      <section className="gpd" data-testid="auv-journey">
        <header className="gpd-head"><h2 className="gpd-title">My Journey</h2>
          <p className="gpd-sub">Every book, from first understanding to who you are becoming.</p></header>
        {data.books.length === 0
          ? <div className="gpd-card gpd-empty"><p>No journey yet.</p></div>
          : data.books.map((b) => <BookJourney key={b.book_id} b={b} readOnly />)}
      </section>
    </div>
  );
}
